module.exports = __webpack_public_path__ + "static/media/accomdation-image.2071d7df.png";